import { Box, FormControl, Grid, Input, InputLabel } from "@mui/material";
import ProductCard from "../../components/ProductCard/ProductCard";
import { useState } from "react";
import { ROUTE_PATH } from "../../helper/Constants";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Spices = () => {
  const { t } = useTranslation();
  const items = useSelector((state) => state.spices.items);

  const [searchText, setSearchText] = useState();

  return (
    <Box sx={{ padding: "10px", textAlign: "left" }}>
      <Box
        sx={{
          padding: "40px 0",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <FormControl>
          <InputLabel htmlFor="search-text">{t("search")}</InputLabel>
          <Input
            id="search-text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        </FormControl>
      </Box>
      <Grid container spacing={1}>
        {items?.length > 0 &&
          items
            .filter(
              (item) =>
                !searchText ||
                item.name.toLowerCase().indexOf(searchText?.toLowerCase()) > -1,
            )
            .map((item, index) => (
              <ProductCard
                key={"best-product" + index}
                item={item}
                type={ROUTE_PATH.SPICES}
              ></ProductCard>
            ))}
      </Grid>
    </Box>
  );
};

export default Spices;
